module.exports = "/assets/ab79032324f4f91d474aced89afe9e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VG.png
// module id = 1925
// module chunks = 0